export class ReassessActionRequiredRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReassessActionRequiredRequest.attributeTypeMap;
    }
    constructor() {
    }
}
